var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white w-full"},[_c('AlertBanner',{attrs:{"page":_vm.basicPage,"slug":_vm.basicSlug}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }